export default function polling(fn: () => unknown, interval = 5000): { stop: () => void } {
  let timerId;
  let stopped = false;
  const iterate = () => Promise.resolve()
    .then(fn)
    .finally(() => {
      if (!stopped) {
        timerId = setTimeout(iterate, interval);
      }
    });

  iterate();
  return {
    stop() {
      stopped = true;
      if (timerId) {
        clearTimeout(timerId);
      }
    }
  };
}
